export function domainCounts(urls: string[]) {
  return urls.reduce((acc: { [domain: string]: string[] }, url) => {
    const domain = domainFromSource(url)
    if (!acc[domain]) {
      acc[domain] = []
    }
    acc[domain].push(url)
    return acc
  }, {})
}

function domainFromSource(source: string) {
  if (source.startsWith('data:')) return 'data'
  return source.split('//').pop()?.split('/')[0] || 'relative'
}

export async function probeImage(url: string, timeout = 10000) {
  return new Promise<{ url: string; ok: boolean }>((resolve) => {
    const img = new Image()
    let done = false
    const timer = setTimeout(() => finish(false), timeout)
    function finish(ok: boolean) {
      if (!done) {
        done = true
        clearTimeout(timer)
        resolve({ url, ok })
      }
    }

    img.onload = () => finish(true)
    img.onerror = () => finish(false)
    img.src = url
  })
}
